import { pluralize } from '@/shared/lib/datetime';
import { Button } from '@/shared/ui/Button';
import { CheckAllIcon } from '@/shared/ui/icons';

interface BulkApproveBarProps {
  pageCount: number;
  running: boolean;
  onApproveAll: () => void;
}

/**
 * Ação em lote da página atual.
 *
 * O texto diz explicitamente "desta página": a API não tem operação em lote, e
 * esconder esse limite faria o operador acreditar que aprovou a fila inteira.
 */
export function BulkApproveBar({ pageCount, running, onApproveAll }: BulkApproveBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-brand-100 bg-brand-50/70 px-5 py-3">
      <p className="text-[0.8125rem] text-brand-900">
        <span className="font-semibold">{pluralize(pageCount, 'inscrição', 'inscrições')}</span> nesta página aguardando decisão.
      </p>

      <Button size="sm" variant="secondary" onClick={onApproveAll} loading={running}>
        <CheckAllIcon className="size-4" />
        Aprovar todas desta página
      </Button>
    </div>
  );
}
